/**
 * 判断交易的准确性 return false交易成功  true交易失败
 * @param {交易执行器} Actuators  
 * @param {交易type} ty 
 */
let tradeAccuracy =function  (Actuators,ty,execer){
  if((Actuators == 'none' || Actuators.substring(0, 5) == "user.")&&!execer){
    return false;
  }else{
    if(ty == 1){
      return true;
    }else{
      return false;
    }
  }
};

let checkIsMobile = function(){
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  let width = document.documentElement.clientWidth;
  return !!(flag || width <= 500)
}

function urlQuery (e) {
  const t=window.location.search.match(new RegExp("(\\?|&)"+e+"=([^&]*)(&|$)"));
  return t?decodeURIComponent(t[2]):""
}

export {
  urlQuery,
  tradeAccuracy,
  checkIsMobile
}